import { render, staticRenderFns } from "./TimelineV2.vue?vue&type=template&id=213a4ef4&scoped=true&"
import script from "./TimelineV2.vue?vue&type=script&lang=js&"
export * from "./TimelineV2.vue?vue&type=script&lang=js&"
import style0 from "./TimelineV2.vue?vue&type=style&index=0&id=213a4ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a4ef4",
  null
  
)

export default component.exports